module.exports = __webpack_public_path__ + "img/12.b45a9f6f.png";